module.exports = __webpack_public_path__ + "static/media/m_hairstyle_quiff_front_vector.e7fcd034.svg";